import React, { useState } from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  const [newsletterEmail, setNewsletterEmail] = useState("");
  const [showNewsletterSuccess, setShowNewsletterSuccess] = useState(false);

  const handleNewsletterSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (newsletterEmail) {
      setShowNewsletterSuccess(true);
      setNewsletterEmail("");
      setTimeout(() => setShowNewsletterSuccess(false), 4000);
    }
  };

  return (
    <div>
      {/* Footer Start */}
      <div
        className="container-fluid footer pt-5 mt-5"
        style={{ backgroundColor: "#0B1320", color: "#E0E0E0" }}
      >
        <div className="container py-5">
          <div className="row g-5">
            {/* Company Section */}
            <div className="col-lg-3 col-md-6">
              <h4 style={{ color: "#D4AF37" }} className="mb-3">
                Via Italia Tours
              </h4>
              <p className="mb-3" style={{ color: "#E0E0E0" }}>
                Your trusted partner for authentic Italian experiences. From Rome to Florence, we bring Italy's magic to life.
              </p>
              {/* <div className="d-flex pt-2">
                <a
                  className="btn btn-sm rounded-circle me-2"
                  href="https://twitter.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ borderColor: "#D4AF37", color: "#D4AF37", border: "1px solid" }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#D4AF37";
                    e.currentTarget.style.color = "#0B1320";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "transparent";
                    e.currentTarget.style.color = "#D4AF37";
                  }}
                >
                  <i className="fab fa-twitter" />
                </a>
                <a
                  className="btn btn-sm rounded-circle me-2"
                  href="https://facebook.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ borderColor: "#D4AF37", color: "#D4AF37", border: "1px solid" }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#D4AF37";
                    e.currentTarget.style.color = "#0B1320";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "transparent";
                    e.currentTarget.style.color = "#D4AF37";
                  }}
                >
                  <i className="fab fa-facebook-f" />
                </a>
                <a
                  className="btn btn-sm rounded-circle me-2"
                  href="https://instagram.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ borderColor: "#D4AF37", color: "#D4AF37", border: "1px solid" }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#D4AF37";
                    e.currentTarget.style.color = "#0B1320";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "transparent";
                    e.currentTarget.style.color = "#D4AF37";
                  }}
                >
                  <i className="fab fa-instagram" />
                </a>
              </div> */}
            </div>

            {/* Quick Links */}
            <div className="col-lg-3 col-md-6">
              <h4 style={{ color: "#D4AF37" }} className="mb-3">
                Quick Links
              </h4>
              <div className="d-flex flex-column">
                <Link to="/" className="mb-2" style={{ color: "#E0E0E0", textDecoration: "none" }} onMouseEnter={(e) => e.currentTarget.style.color = "#87CEEB"} onMouseLeave={(e) => e.currentTarget.style.color = "#E0E0E0"}>
                  <i className="fa fa-angle-right me-2" style={{ color: "#D4AF37" }} />
                  Home
                </Link>
                {/* <Link to="/About" className="mb-2" style={{ color: "#E0E0E0", textDecoration: "none" }} onMouseEnter={(e) => e.currentTarget.style.color = "#87CEEB"} onMouseLeave={(e) => e.currentTarget.style.color = "#E0E0E0"}>
                  <i className="fa fa-angle-right me-2" style={{ color: "#D4AF37" }} />
                  About Us
                </Link>
                <Link to="/Services" className="mb-2" style={{ color: "#E0E0E0", textDecoration: "none" }} onMouseEnter={(e) => e.currentTarget.style.color = "#87CEEB"} onMouseLeave={(e) => e.currentTarget.style.color = "#E0E0E0"}>
                  <i className="fa fa-angle-right me-2" style={{ color: "#D4AF37" }} />
                  Services
                </Link>
                <Link to="/Tours" className="mb-2" style={{ color: "#E0E0E0", textDecoration: "none" }} onMouseEnter={(e) => e.currentTarget.style.color = "#87CEEB"} onMouseLeave={(e) => e.currentTarget.style.color = "#E0E0E0"}>
                  <i className="fa fa-angle-right me-2" style={{ color: "#D4AF37" }} />
                  Tours
                </Link> */}
                <Link to="/Contact" className="mb-2" style={{ color: "#E0E0E0", textDecoration: "none" }} onMouseEnter={(e) => e.currentTarget.style.color = "#87CEEB"} onMouseLeave={(e) => e.currentTarget.style.color = "#E0E0E0"}>
                  <i className="fa fa-angle-right me-2" style={{ color: "#D4AF37" }} />
                  Contact
                </Link>
              </div>
            </div>

            {/* Contact Section */}
            <div className="col-lg-3 col-md-6">
              <h4 style={{ color: "#D4AF37" }} className="mb-3">
                Contact Info
              </h4>
              <p className="mb-2" style={{ color: "#E0E0E0" }}>
                <i className="fa fa-map-marker-alt me-3" style={{ color: "#D4AF37" }} />
                Via dei Fori Imperiali, 10<br />
                00184 Roma RM, Italy
              </p>
              <p className="mb-2" style={{ color: "#E0E0E0" }}>
                <i className="fa fa-phone-alt me-3" style={{ color: "#D4AF37" }} />
                +39 06 1234 5678
              </p>
              <p className="mb-2" style={{ color: "#E0E0E0" }}>
                <i className="fa fa-envelope me-3" style={{ color: "#D4AF37" }} />
                info@viaitaliatours.com
              </p>
              <p className="mb-2" style={{ color: "#E0E0E0" }}>
                <i className="fa fa-clock me-3" style={{ color: "#D4AF37" }} />
                Mon-Sat: 9:00 AM - 7:00 PM
              </p>
            </div>

            {/* Newsletter Section */}
            <div className="col-lg-3 col-md-6">
              <h4 style={{ color: "#D4AF37" }} className="mb-3">
                Newsletter
              </h4>
              <p style={{ color: "#E0E0E0" }}>Subscribe for exclusive Italian tours & updates.</p>
              
              {showNewsletterSuccess && (
                <div className="alert alert-success rounded-pill py-2 mb-3 text-center" style={{ backgroundColor: "#D4AF37", color: "#0B1320", border: "none", fontSize: "12px" }}>
                  <i className="fa fa-check-circle me-1" /> Subscribed! Grazie!
                </div>
              )}
              
              <form onSubmit={handleNewsletterSubmit}>
                <div className="position-relative mx-auto" style={{ maxWidth: 400 }}>
                  <input
                    className="form-control w-100 py-3 ps-4 pe-5 rounded-pill"
                    type="email"
                    placeholder="Your email address"
                    style={{ borderColor: "#D4AF37", backgroundColor: "#1a2530", color: "#FFFFFF" }}
                    value={newsletterEmail}
                    onChange={(e) => setNewsletterEmail(e.target.value)}
                    required
                  />
                  <button
                    type="submit"
                    className="btn py-2 px-4 position-absolute top-0 end-0 mt-2 me-2 rounded-pill"
                    style={{
                      backgroundColor: "#D4AF37",
                      color: "#0B1320",
                      border: "none",
                      fontWeight: "bold",
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#87CEEB"}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "#D4AF37"}
                  >
                    Subscribe
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="container" style={{ borderTop: "1px solid rgba(212, 175, 55, 0.2)" }}>
          <div className="copyright py-3">
            <div className="row">
              <div
                className="col-md-6 text-center text-md-start mb-3 mb-md-0"
                style={{ color: "#E0E0E0" }}
              >
                ©{" "}
                <Link
                  className="border-bottom"
                  to="/"
                  style={{ color: "#D4AF37", textDecoration: "none" }}
                >
                  Via Italia Tours
                </Link>
                , All Rights Reserved.
              </div>
              <div className="col-md-6 text-center text-md-end">
                <div className="footer-menu">
                  <Link to="/" style={{ color: "#E0E0E0", marginLeft: "15px", textDecoration: "none" }} onMouseEnter={(e) => e.currentTarget.style.color = "#87CEEB"} onMouseLeave={(e) => e.currentTarget.style.color = "#E0E0E0"}>
                    Home
                  </Link>
                  {/* <Link to="/About" style={{ color: "#E0E0E0", marginLeft: "15px", textDecoration: "none" }} onMouseEnter={(e) => e.currentTarget.style.color = "#87CEEB"} onMouseLeave={(e) => e.currentTarget.style.color = "#E0E0E0"}>
                    About
                  </Link> */}
                  <Link to="/Contact" style={{ color: "#E0E0E0", marginLeft: "15px", textDecoration: "none" }} onMouseEnter={(e) => e.currentTarget.style.color = "#87CEEB"} onMouseLeave={(e) => e.currentTarget.style.color = "#E0E0E0"}>
                    Contact
                  </Link>
                  {/* <a href="#" style={{ color: "#E0E0E0", marginLeft: "15px", textDecoration: "none" }} onMouseEnter={(e) => e.currentTarget.style.color = "#87CEEB"} onMouseLeave={(e) => e.currentTarget.style.color = "#E0E0E0"}>
                    Privacy Policy
                  </a> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Footer End */}
    </div>
  );
}